import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import zhTranslations from './locales/zh.json';

// 语言配置
export const LANGUAGES = [
  { code: 'en-us', name: 'English', flag: '🇬🇧' },
  { code: 'zh-cn', name: '中文', flag: '🇨🇳' },
] as const;

export type LanguageCode = 'en-us' | 'zh-cn';

// 默认语言
export const DEFAULT_LANGUAGE: LanguageCode = 'en-us';

// 🔥 同步 <html lang> 属性，让浏览器原生控件（如 <input type="date">）使用正确的语言
const syncHtmlLang = (lng: string) => {
  // i18n 内部 lng 为 'en'/'zh'，映射到标准 BCP 47 语言标签
  const langMap: Record<string, string> = { en: 'en', zh: 'zh-CN' };
  document.documentElement.lang = langMap[lng] || lng;
};

// i18n 配置
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    zh: {
      translation: zhTranslations,
    },
  },
  lng: 'en', // 固定默认语言为英文，不自动检测
  fallbackLng: 'en',
  debug: false,

  interpolation: {
    escapeValue: false, // React 已经默认转义了
  },

  react: {
    useSuspense: false,
  },
});

// 🔥 初始化时同步一次
syncHtmlLang(i18n.language);

// 🔥 监听语言切换事件，实时同步 <html lang>
i18n.on('languageChanged', syncHtmlLang);

export default i18n;

// 切换语言的工具函数
export const changeLanguage = (lng: LanguageCode) => {
  i18n.changeLanguage(lng);
};

// 获取当前语言
export const getCurrentLanguage = (): LanguageCode => {
  return i18n.language as LanguageCode;
};
